<template>
    <div id="footerNavigation">
        <button :class="this.$route.name == 'home' || this.$route.name == 'home2'?'active':''" @click="$router.push('/home/'+this.routeParams)"><div class="buttonIcon house fa">&#xf015;</div><div class="buttonText">Start</div></button>
        <button :class="this.$route.name == 'einsatz'?'active':''" @click="$router.push('/einsatz/'+this.routeParams)"><div class="buttonIcon bell fa">&#xf0f3;</div><div class="buttonText">Einsatz</div></button>
        <button :class="this.$route.name == 'lern-hub'?'active':''" @click="$router.push('/lern-hub/'+this.routeParams)"><div class="buttonIcon learn fa">&#xf19d;</div><div class="buttonText">Lernen</div></button>
        <button :class="this.$route.name == 'mehr'?'active':''"  @click="$router.push('/mehr/'+this.routeParams)"><div class="buttonIcon more fa">&#xf141;</div><div class="buttonText">Mehr</div></button>
    </div>
</template>

<script>
export default {
    name: 'footerNavigation',
    components: {
    },
    props:{

    },
    data() {
      return{
        routeParams: String,
      }
    },
    methods:{

    },
    watch: {
        $route(to, from){
        this.menuActive = false;
        }
    },
    created() {
        this.routeParams = this.$route.params.id;
    },
}
</script>

<style lang="scss" scoped>
#footerNavigation{
    width: 100vw;
    height: 4.3rem;
    background-color: white;
    position: fixed;
    bottom: 0;
    border: 1px solid rgb(236, 236, 236);
    border-radius: 8px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    display: flex;
    justify-content: space-evenly;
}

button{
    //width: 22vw;
    //margin: 0.8rem;
    //padding: 0.8rem;
    width: 25vw;
    background-color: transparent;
    border: none;
    //border-right: solid rgb(219, 219, 219) 1px;
    color: rgb(109, 109, 109);
}

.buttonIcon{
    font-size: x-large;
}

.buttonText{
    margin-top: 0.1rem;
}

.active{
    color: black;
}

.active .house{
    animation: jumpAndScale 0.5s forwards;
}

.active .bell{
    animation: bellRing 0.5s forwards;
}

.active .learn{
    animation: hatJumpSpin 0.5s forwards;
}

.active .more{
    animation: rotateLeftRight 0.5s forwards;
}

@keyframes jumpAndScale {
    0% {
        transform: scale(1);      /* Startgröße */
    }
    20% {
        transform: scale(0.9);    /* kurz kleiner */
    }
    50% {
        transform: scale(1.1) translateY(-0.6rem); /* hochspringen */
    }
    70% {
        transform: scale(1);      /* zurück auf normale Größe */
    }
    100% {
        transform: scale(1);      /* Endposition */
    }
}

@keyframes bellRing {
    0% { transform: rotate(0deg); }
    15% { transform: rotate(15deg); }
    30% { transform: rotate(-10deg); }
    45% { transform: rotate(15deg); }
    60% { transform: rotate(-10deg); }
    75% { transform: rotate(15deg); }
    100% { transform: rotate(0deg); }
}

@keyframes hatJumpSpin {
    0%   { transform: translateY(0) rotate(0deg) scale(1); }
    10%  { transform: translateY(-0.2rem) rotate(36deg) scale(1.05); }
    20%  { transform: translateY(-0.4rem) rotate(72deg) scale(1.1); }
    30%  { transform: translateY(-0.6rem) rotate(108deg) scale(1.15); }
    40%  { transform: translateY(-0.8rem) rotate(144deg) scale(1.18); }
    50%  { transform: translateY(-1rem) rotate(180deg) scale(1.2); }  /* höchste Stelle */
    60%  { transform: translateY(-0.8rem) rotate(216deg) scale(1.18); }
    70%  { transform: translateY(-0.6rem) rotate(252deg) scale(1.15); }
    80%  { transform: translateY(-0.4rem) rotate(288deg) scale(1.1); }
    90%  { transform: translateY(-0.2rem) rotate(324deg) scale(1.05); }
    100% { transform: translateY(0) rotate(360deg) scale(1); }
}

@keyframes rotateLeftRight{
    0% { transform: rotate(0deg); }
    12% { transform: rotate(15deg); }
    24% { transform: rotate(30deg); }
    36% { transform: rotate(15deg); }
    48% { transform: rotate(0deg); }
    60% { transform: rotate(-15deg); }
    72% { transform: rotate(-30deg); }
    84% { transform: rotate(-15deg); }
    96% { transform: rotate(0deg); }
    100% { transform: rotate(0deg); }
}
</style>